// extracted by mini-css-extract-plugin
export var card = "Card-module--card--02b2b";
export var cta = "Card-module--cta--b976c";
export var description = "Card-module--description--83280";
export var image = "Card-module--image--2214b";
export var readingTime = "Card-module--reading-time--32fd4";
export var title = "Card-module--title--fa966";
export var type = "Card-module--type--fa2b5";
export var whiteBackground = "Card-module--white-background--7a369";